var _style, _polyline, _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgOpenMenuBackgroundTopRight = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  id: "OpenMenuBackground_TopRight",
  x: "0px",
  y: "0px",
  viewBox: "0 0 97.8 710",
  style: {
    enableBackground: "new 0 0 97.8 710"
  },
  xmlSpace: "preserve",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\r\n\t.st0v{fill:#38555A;}\r\n\t.st1v{fill:none;stroke:#000000;stroke-width:2;stroke-miterlimit:10;}\r\n")), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
  className: "st0v",
  points: "0,111.9 0,445.2 96.8,482.5 96.8,70.1 "
})), _line || (_line = /*#__PURE__*/React.createElement("line", {
  className: "st1v",
  x1: 96.8,
  y1: 710,
  x2: 96.8,
  y2: 0
})));
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgOpenMenuBackgroundTopRight, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/OpenMenuBackground_TopRight.41bfc084.svg";
export { ForwardRef as ReactComponent };